import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2a4afd20&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=2a4afd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4afd20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4afd20')) {
      api.createRecord('2a4afd20', component.options)
    } else {
      api.reload('2a4afd20', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2a4afd20&scoped=true&", function () {
      api.rerender('2a4afd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deposit/components/deposit/detail.vue"
export default component.exports